import { render } from "./UploadGeneralDoc.vue?vue&type=template&id=0a3650f5&scoped=true&ts=true"
import script from "./UploadGeneralDoc.vue?vue&type=script&lang=ts"
export * from "./UploadGeneralDoc.vue?vue&type=script&lang=ts"

import "./UploadGeneralDoc.vue?vue&type=style&index=0&id=0a3650f5&scoped=true&lang=css"
import "./UploadGeneralDoc.vue?vue&type=style&index=1&id=0a3650f5&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3650f5"]])

export default __exports__